import * as React from 'react'
import { CheckIcon, MinusIcon } from 'lucide-react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer group/checkbox size-4 shrink-0 rounded-sm border border-neutral-ui-border bg-neutral-app-bg transition-shadow outline-none',
        'focus-visible:ring-2 focus-visible:ring-primary-solid focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
        'data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
        'aria-invalid:border-destructive aria-invalid:bg-error-ui-bg aria-invalid:ring-destructive/20',
        'aria-invalid:data-[state=checked]:bg-destructive aria-invalid:data-[state=checked]:border-destructive',
        'aria-invalid:data-[state=indeterminate]:bg-destructive aria-invalid:data-[state=indeterminate]:border-destructive',
        'dark:aria-invalid:ring-destructive/40',
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none">
        <CheckIcon className="hidden size-3.5 group-data-[state=checked]/checkbox:block" />
        <MinusIcon className="hidden size-3.5 group-data-[state=indeterminate]/checkbox:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
